import { render } from "./LessonPage.vue?vue&type=template&id=34868f64&scoped=true"
import script from "./LessonPage.vue?vue&type=script&lang=js"
export * from "./LessonPage.vue?vue&type=script&lang=js"

import "./LessonPage.vue?vue&type=style&index=0&id=34868f64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34868f64"]])

export default __exports__